export const DECIMAL: string = 'Decimal'
